export const ReceiveIcon = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
      fill="#2E7D32"
    />
    <path
      d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z"
      stroke="#E5E7EB"
    />
    <g clipPath="url(#clip0_48_519)">
      <path
        d="M23 29.7547L32 23.0891L41 29.7547V31.9766L33.5703 37.4844C33.1156 37.8219 32.5672 38 32 38C31.4328 38 30.8844 37.8172 30.4297 37.4844L23 31.9766V29.7547ZM32 20C31.4328 20 30.8844 20.1828 30.4297 20.5156L21.2141 27.3453C20.45 27.9125 20 28.8031 20 29.7547V41C20 42.6547 21.3453 44 23 44H41C42.6547 44 44 42.6547 44 41V29.7547C44 28.8031 43.55 27.9078 42.7859 27.3453L33.5703 20.5156C33.1156 20.1828 32.5672 20 32 20Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_48_519">
        <path d="M20 20H44V44H20V20Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ReceiveIcon;
